const phrases = {
  'Location not found': 'No encontrado',
  'Next 12 Hours': 'Próximas 12 Horas',
  'Nothing to find': 'No encontrado',
  'Enter Zip Code': 'Código postal',
  'Station Locations': 'Estación',
  'Feels Like': 'Se sentirá como',
  'Heat Index': 'índice calor',
  'Wind Chill': 'Enfriamiento',
  'Description': 'Descripción',
  'Custom Locations': 'Otro',
  'Moonrise': 'Salida Lunar',
  'Moon Phase': 'Fase Lunar',
  'Weekend': 'Fin de Semana',
  'Moonset': 'Puesta Lunar',
  'UV Index': 'índice UV',
  'Sunrise': 'Amanecer',
  'Sunset': 'Atardecer',
  'Pressure': 'Presión',
  'Windspeed': 'Viento',
  'Humidity': 'Humedad',
  'Hourly': 'Cada Hora',
  'Cancel': 'Cancelar',
  'NICKNAME': 'apodo',
  'EDIT': 'EDITAR',
  'Edit': 'Editar',
  'Wind': 'Viento',
  'Time': 'Hora',
  'Save': 'OK',
  'Day': 'Día',
  'H': 'Mx',
  'L': 'Mn',
  'Read More': 'Lee Más',
  'Meet the team': 'Conocer al equipo',
  'View More': 'Ver más',
  'NIGHT': 'NOCHE',
};

export default function translate (english, lang) {
  return (lang === 'es' && english in phrases) ? phrases[english] : english;
}



// WEBPACK FOOTER //
// ./app/utils/translate.js